module.exports = __webpack_public_path__ + "img/logo.94d27b9b.svg";